import React, { useReducer, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { getActiveMenu } from '../../apis/getActiveMenu';

import { AuthContext } from '../../reducers/Auth/AuthContext';
import PlaceReducer from './PlaceReducer';
import { initialState } from './PlaceInitialState';

export const PlaceStoreContext = React.createContext(initialState);
export const PlaceStore = ({ children }) => {
  const history = useHistory();
  const [state, dispatch] = useReducer(PlaceReducer, initialState);
  const [authState] = useContext(AuthContext);
  const { authenticated, user } = authState;
  const { placeId, userId } = user;
  const isAuthenticated = authenticated && placeId && userId;

  useEffect(() => {
    const placeIdFromPlaceState = state?.place?.id;
    const hasStatePlaceId = Boolean(placeIdFromPlaceState);
    const hasAuthPlaceId = Boolean(placeId);
    const differentPlaceIds = hasStatePlaceId && placeIdFromPlaceState !== placeId;
    const samePlaceId = hasAuthPlaceId && hasStatePlaceId && placeIdFromPlaceState === placeId;

    if (isAuthenticated && samePlaceId) {
      return;
    }

    if (isAuthenticated) {
      if (differentPlaceIds) {
        dispatch({ type: 'RESET', payload: {} });
        return;
      }

      console.log('GETTING MENU');
      getMenu();
    } else {
      dispatch({ type: 'RESET', payload: {} });
    }
  }, [isAuthenticated, state]);

  useEffect(() => {
    if (!authState.placeId || !authState.userId) {
      return;
    }

    if (state.error) {
      console.log('ERROR DETECTED PLACE', state.error);
      history.replace('/error');
    }
  }, [state, authState]);

  const getMenu = async () => {
    if (state.loading || !placeId || !isAuthenticated) return;
    const payload = await getActiveMenu(placeId);
    dispatch({ type: 'LOAD_MENU', payload });
  };

  return (
    <PlaceStoreContext.Provider value={[state, dispatch, { getMenu }]}>
      {children}
    </PlaceStoreContext.Provider>
  );
};

export default PlaceStore;

// const initialState = {
//   authenticated: false,
//   user: {
//     id: null,
//     alias: null,
//     role: null,
//     placeId: null,
//   },
//   loading: false,
// };
